// removed by extract-text-webpack-plugin
module.exports = {"main":"_15RmxRREcC1Nc_qvsimFHH"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptStamp.module.css
// module id = 2368
// module chunks = 1